import { ddjMiddleware } from './middleware';

export const ddjConfiguration = {
    middleware: ddjMiddleware
};
